import { useEffect, useRef, useState } from 'react';
import styles from './rentalapplicationnoaptsuccess.module.css';
import axios from 'axios';
import Helmet from "react-helmet";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const RentalApplicationNoaptSuccess = ({ history, match }) => {
    const { str } = match.params;
    const redirect = useHistory();
    const [propertyDet, setPropertyDet] = useState(null);
    const [applicantDet, setApplicantDet] = useState(null);
    const [showPopup, setShowPopup] = useState(true);
    const timeoutRef = useRef(null);

    useEffect(() => {
        async function fetchByID() {
            await axios.get(process.env.REACT_APP_APPLICANT_API_URL + 'v1/application-det-payment/' + str
            ).then(response => {
                if (response?.data?.isPaid === 1) {
                    redirect.push('/rental-application-success/' + response?.data?.propertyDetails?.id);
                }

                setPropertyDet(response?.data?.propertyDetails);
                setApplicantDet(response?.data?.applicantDetails);
            }).catch(error => {
                redirect.push('/rental-application-invalid');
            });
        }
        fetchByID();
    }, [str]);

    const checkVerify = () => {
        try {
            axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/check-verification/" + applicantDet?.id).then((response) => {
                if (response?.data?.data) {
                    setShowPopup(false);
                    clearTimeout(timeoutRef.current);
                } else {
                    timeoutRef.current = setTimeout(checkVerify, 3000);
                }
            }).catch((error) => {
                timeoutRef.current = setTimeout(checkVerify, 3000);
            });
        } catch (error) {
            timeoutRef.current = setTimeout(checkVerify, 3000);
        }
    }

    useEffect(() => {
        if (applicantDet?.id) {
            checkVerify();

            return () => {
                clearTimeout(timeoutRef.current);
            }
        }
    }, [applicantDet?.id]);

    const verifyNow = () => {
        window.open('/verify/' + applicantDet?.verify_url_token, '_blank');
    }

    const handleClose = (event, reason) => {
        if (reason && reason === 'backdropClick') return;

        setShowPopup(false);
    }

    return (<>
        <Helmet title="Application Received" />

        <section className={`${styles.EmptySection}`}>

            <div className={`${styles.IconWrap}`}>
                <svg className={`${styles.CircleSvg}`} viewBox="0 0 90 90">
                    <circle className={`${styles.CircleBG}`} cx="45" cy="45" r="35" />
                    <circle className={`${styles.CircleProgress}`} cx="45" cy="45" r="35" transform="rotate(-90 45 45)" />
                    <path className={`${styles.CheckPath}`} d="M30 45l11 11 19-22" />
                </svg>
            </div>

            <div className={`${styles.StatusPill}`}>
                <span className={`${styles.PillDot}`}></span>
                Application Received
            </div>

            <h2 className={`${styles.EmptyTitle}`}>Thanks! We've got<br />your <em>details</em>.</h2>

            <p className={`${styles.EmptySub}`}>Unfortunately, no apartments are available at {propertyDet?.name} right now — but your application is saved and you're on our priority list.</p>
            <p className={`${styles.EmptySub2}`}>Once apartments become available, we’ll notify you immediately so you can continue your application by completing the $40 application and tenant screening fee.</p>
            <p className={`${styles.EmptySub2}`}>In the meantime, feel free to contact us directly if you have any questions.</p>

            {/* <div className={`${styles.CardsRow}`}>
                <div className={`${styles.InfoCard}`}>
                    <div className={`${styles.InfoCardLabel}`}>Call us</div>
                    <div className={`${styles.InfoCardValue}`}><a href="tel:+1{propertyDet?.phone.replace(/\D/g, '')}">{propertyDet?.phone}</a></div>
                </div>
                <div className={`${styles.InfoCard}`}>
                    <div className={`${styles.InfoCardLabel}`}>Email us</div>
                    <div className={`${styles.InfoCardValue}`}><a href="mailto:{propertyDet?.email}">{propertyDet?.email}</a></div>
                </div>
                <div className={`${styles.InfoCard}`}>
                    <div className={`${styles.InfoCardLabel}`}>Address</div>
                    <div className={`${styles.InfoCardValue}`}>{propertyDet?.address}<br />{propertyDet?.city}, {propertyDet?.state} {propertyDet?.zip}</div>
                </div>
            </div> */}

            <div className={`${styles.Actions}`}>
                {/* <a href="tel:+1{propertyDet?.phone.replace(/\D/g, '')}" className={`${styles.BtnPrimary}`}>Call Us Now</a> */}
                <Link to={"/"} className={`${styles.BtnOutline}`}>Back to Home</Link>
            </div>

            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>
                    <div className={`${styles.footerMainLeft}`}>
                        <Link to={"/"}>
                            <img src={propertyDet?.image !== "" ? propertyDet?.image : "/static/img/logo.svg"} alt="logo" />
                        </Link>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li>
                                    <a href={`mailto: ${propertyDet?.email}`}>{propertyDet?.email}</a>
                                </li>
                                <li>
                                    <a href="tel:+1{propertyDet?.phone.replace(/\D/g, '')}">{propertyDet?.phone}</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>
                                    {propertyDet?.address} <br />
                                    {propertyDet?.city}, {propertyDet?.state}{" "}
                                    {propertyDet?.zip}
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li>
                                    <Link to={"/privacy-policy"}>Privacy Policy</Link>
                                </li>
                                <li>
                                    <Link to={"/eula"}>End User License Agreement</Link>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>Propertydek © {moment().format("YYYY")}.<br />All rights reserved.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </section>

        <Dialog
            open={showPopup}
            fullWidth
            maxWidth="sm"
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp NewPopUp2"
        >
            <DialogTitle id="alert-dialog-title">Secure Your Application: ID Verification</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">To ensure property security and finalize your application, we need to verify your identity. This is a standard security measure.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="SubmitPopupBU" onClick={(e) => verifyNow()}>Verify Identity Now</Button>
            </DialogActions>
        </Dialog>
    </>)
}

export default RentalApplicationNoaptSuccess;